<div class="sales-cost-lookup-dialog">
  <div class="flex align-items-center gap-2 mb-3">
    <label class="font-semibold white-space-nowrap">Find</label>
    <input
      pInputText
      [(ngModel)]="searchKeyword"
      class="flex-1"
    />
  </div>

  <div class="table-scroll-wrapper">
  <p-table
    [value]="filteredData"
    [dataKey]="dataKey"
    selectionMode="single"
    [(selection)]="selectedRow"
    [loading]="loading"
    [scrollable]="true"
    scrollHeight="300px"
    styleClass="p-datatable-gridlines p-datatable-sm p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of columns">{{ col.header }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr [pSelectableRow]="row" (dblclick)="onRowDblClick(row)" style="cursor: pointer;">
        <td *ngFor="let col of columns">{{ row[col.field] }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [colSpan]="columns.length">{{ 'table.no-records-found' | translate }}</td>
      </tr>
    </ng-template>
  </p-table>
  </div>

  <div class="flex justify-content-center gap-2 mt-3">
    <button
      type="button"
      pButton
      label="OK"
      [disabled]="!selectedRow"
      (click)="onOk()">
    </button>
    <button
      type="button"
      pButton
      label="Cancel"
      class="p-button-outlined"
      (click)="onCancel()">
    </button>
  </div>
</div>
